import { createSlice } from '@reduxjs/toolkit';
import { USER_ROLE } from 'FEATURES/teams/constants';

const initialState = {
  teamsMeetingDetail: {},
  currentUserRole: USER_ROLE.ANONYMOUS,
  interpreterMeetings: [],
  participantAcsId: undefined,
};

const teamsMeetingSlice = createSlice({
  name: 'teamsMeeting',
  initialState,
  reducers: {
    setMeetingDetails(state, action) {
      state.teamsMeetingDetail = action.payload;
      if (action.payload?.interpretation) {
        const { interpreterMeetings, participantId } = action.payload.interpretation;
        state.interpreterMeetings = interpreterMeetings;
        state.participantAcsId = participantId;
      }
    },
    setCurrentUserRole(state, action) {
      state.currentUserRole = action.payload;
    },
    updateInterpretingLanguages(state, action) {
      state.interpreterMeetings = action.payload.map((value) => ({
        language: value,
      }));
    },
    updateMeetingDetailsUniversalAccess(state, action) {
      state.teamsMeetingDetail.universalAccessEnabled = action.payload;
    },
  },
});

export default teamsMeetingSlice.reducer;

export const teamsMeetingActions = { ...teamsMeetingSlice.actions };

export const teamsMeetingSelector = {
  teamsMeetingDetail: (store) => store.teamsMeeting.teamsMeetingDetail,
  currentUserRole: (store) => store.teamsMeeting.currentUserRole,
  languages: (store) => store.teamsMeeting.interpreterMeetings.map((item) => item.language),
};

export const selectInterpretationLanguages = (state) =>
  state.teamsMeeting.interpreterMeetings.map((item) => item.language);
